"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var getItemIdsFromConversations_1 = require("owa-mail-list-store/lib/utils/getItemIdsFromConversations");
var Store_1 = require("owa-mail-list-store/lib/store/Store");
var actionTypes_1 = require("owa-mail-store/lib/actions/actionTypes");
var setConversationInferenceClassificationService_1 = require("owa-mail-triage-action/lib/services/setConversationInferenceClassificationService");
var undoActions = require("owa-mail-undo");
var legacy_1 = require("satcheljs/lib/legacy");
var stitch_1 = require("satcheljs/lib/legacy/stitch");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var owa_mail_feature_flags_1 = require("owa-mail-feature-flags");
var owa_analytics_1 = require("owa-analytics");
var owa_mail_inference_tracking_1 = require("owa-mail-inference-tracking");
var datapoints_1 = require("../datapoints");
var owa_mail_list_store_2 = require("owa-mail-list-store");
/**
 * move to focused/other action
 * @param conversationRowKeys the specified rowKeys
 * @param tableViewId the table view id
 * @param actionSource the source that initiated this action
 * @return the action response
 */
exports.default = legacy_1.action('moveConversationToFocusedOrOtherAction', datapoints_1.default.moveConversationToFocusedOrOther)(function moveConversationToFocusedOrOther(conversationRowKeys, tableViewId, actionSource) {
    var tableView = Store_1.default.tableViews.get(tableViewId);
    var focusedViewFilter = owa_mail_list_store_1.getFocusedFilterForTable(tableView);
    var isFocusedView = focusedViewFilter == 0 /* Focused */;
    var conversationIdStrings = owa_mail_list_store_2.getRowIdsFromRowKeys(conversationRowKeys, tableViewId);
    undoActions.clearLastUndoableAction();
    setConversationInferenceClassificationService_1.setConversationInferenceClassificationService(conversationIdStrings, isFocusedView ? 'Other' : 'Focused');
    if (owa_mail_feature_flags_1.isMailFeatureEnabled('tri-nonSubstrateInference')) {
        var itemIdsToLog_1 = getItemIdsFromConversations_1.default(conversationRowKeys, tableViewId);
        var activityTime_1 = new Date().toISOString();
        owa_mail_inference_tracking_1.lazyBuildInferenceDatapoint.import().then(function (buildInferenceDatapoint) {
            owa_analytics_1.lazyLogCustomDataLoggerDatapoint.importAndExecute(buildInferenceDatapoint(tableView.serverFolderId, focusedViewFilter, activityTime_1, isFocusedView ? "MarkAsOther" /* MarkAsOther */ : "MarkAsFocused" /* MarkAsFocused */, itemIdsToLog_1));
        });
    }
    // raise stitch to delete conversation from list view and reading pane
    // VSO 20053:Tombstone not working when moving conversation from focused to other
    stitch_1.raiseAction(actionTypes_1.actionNames.DeleteConversationStoreUpdate)(conversationIdStrings, tableView);
});
//# sourceMappingURL=moveConversationToFocusedOrOther.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/conversations/moveConversationToFocusedOrOther.js
// module id = 5617
// module chunks = 62